import type { NhsAppRuntimeContext } from '@core/entities/NhsAppRuntime';
import type { NhsAppGateway } from '@core/ports/NhsAppGateway';

export class DetectNhsAppRuntimeUseCase {
  public constructor(private readonly nhsAppGateway: NhsAppGateway) {}

  public execute(): Promise<NhsAppRuntimeContext> {
    return this.nhsAppGateway.detectRuntime();
  }
}